module.exports = __webpack_public_path__ + "static/media/01_L.375ce7b0.png";